export default {"src":"/_next/static/media/loader.5b78cd08.gif","height":600,"width":800,"blurWidth":0,"blurHeight":0};